import { Objects, UIImages } from '../utils/Consts';
import BaseOverlay from './BaseOverlay';
import Utils from '../utils/Utils';

class TranslationOverlay extends BaseOverlay {
	constructor(scene, uiHandler, audioManager) {
		super(scene, uiHandler, audioManager);
		this.translation = this.uiHandler.createImage(Utils.centerX(), Utils.centerY(), UIImages.translationBasic);
		this.assetContainer.add(this.translation);
		this.hide(false);
	}

	hide(hiddenByPlayer = true) {
		super.hide();
		this.translation.setVisible(this.visible);
		this.translation.disableInteractive();

		if (hiddenByPlayer && this.scene.gameState.translationFound === false) {
			this.scene.gameState.translationFound = true;
			this.scene.objectsManager.appearAnimation(Objects.translationLocated);
		}
	}

	show() {
		super.show();
		this.translation.setVisible(this.visible);
		this.translation.setInteractive();
	}
}

export default TranslationOverlay;
